import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BankData} from "./BankData";
import {PaymentService} from "../payment.service";
import {FonctionUtiles} from "../../fo/fonctionsUtiles";
import {remoteMpiArray} from "./remoteMpiArray";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-paiement-module',
  templateUrl: './paiement-module.component.html',
  styleUrls: ['./paiement-module.component.css']
})
export class PaiementModuleComponent implements OnInit {

  bankData :BankData = new  BankData();
  errors : any = [];
  @Output() messageEvent = new EventEmitter<any>();
  order:any;
  frais:any;
  pricings:any;
  event:any;
  devise:any;
  Total:any;
  nbreTicket:any;
  daysArray:any = [];
  monthsArray:any = [];
  exp_day:number;
  exp_month:number;
  pendingRequest: boolean = false;
  currenteventUrl:any;
  id3: any;

  constructor( private paymentService:PaymentService,public functionUtils:FonctionUtiles) {}

  ngOnInit() {
    this.order = this.paymentService.retrieve('order');
    this.pricings = this.paymentService.retrieve('pricings');
    this.event = this.paymentService.retrieve('event');
    this.currenteventUrl =  this.paymentService.retrieve('currenteventUrl');
    this.setDevises(this.event);
    this.initMonthsAndDaysSelectArrays();
    const urlString = window.location.href;
    const url = new URL(urlString);
    this.id3 = url.searchParams.get('id3');
    if (this.id3) {
      this.onSubmit(true);
    }
  }


  onSubmit(validity) {
    this.order = this.paymentService.retrieve('order');
    this.order.total_price = Math.round((this.order.total_price + Number.EPSILON) * 100) / 100;
    if (this.id3) {
      this.order['id3'] = this.id3;
      this.bankData =  this.paymentService.retrieve('bankData');
    } else {
      this.paymentService.store('bankData', this.bankData);
      // this.errors.push('Payement refusé ,vueillez reéssayer ultérieurement');
    }
    if(this.paymentService.retrieve('sessionExpirationTime') > 0) {
      this.cleanErrors();
      if(!validity) {
        this.errors.push('Vous devez renseigner toutes les données');
        return;
      } else {
        this.order['bankData'] = this.bankData;
        this.ValidatePayment();
      }
    } else {
      if(confirm('Votre session a expiré, Vous allez être rediriger sur la page de l\'évènement')) {
        window.location.href = this.currenteventUrl;
        return;
      }
    }
  }
  setDevises(event) {
    if(event.currency) {
      this.devise = event.currency
    } else {
      this.devise = 'Eur'
    }
  }
  cleanErrors() {
    this.errors = [];
    this.pendingRequest = false;
  }
  formatDollarsToCents(value): any {
    value = (value + '').replace(/[^\d.-]/g, '');
    if (value && value.includes('.')) {
      value = value.substring(0, value.indexOf('.') + 3);
    }
    return value ? Math.round(parseFloat(value) * 100) : 0;
  }

  isFree(pendingRequest,order){
    return !pendingRequest && parseInt(order.total_price) === 0
  }

  ValidatePayment() {

    if(!this.paymentService.retrieve('isNormalPayment') && !this.paymentService.retrieve('I_undertake_to_honor')) {
      alert('vous devez vous engagez à honorer');
      return;
    }
    if (!this.id3 && this.order.total_price > 0) {
      const f = document.createElement('form');
      f.setAttribute('method', 'post');
      f.style.visibility = 'hidden';
      f.setAttribute('action', environment.dddSecureUrl);
      for (const remoteMpi of remoteMpiArray) {
        const i = document.createElement( 'input');
        if (remoteMpi.name === 'Amount') {
          i.setAttribute('type', 'hidden');
          i.setAttribute('name', remoteMpi.name);
          i.setAttribute("type", "number");
          i.setAttribute('value',this.formatDollarsToCents(this.order.total_price) );
        } else if (remoteMpi.name === 'CCNumber') {
          i.setAttribute('type', 'hidden');
          i.setAttribute('name', remoteMpi.name);
          i.setAttribute('value', this.bankData.card_number);
        } else if (remoteMpi.name === 'CCExpDate') {
          i.setAttribute('type', 'hidden');
          i.setAttribute('name', remoteMpi.name);
          i.setAttribute('value', this.bankData.exp_date);
        } else if (remoteMpi.name === 'CVVCode') {
          i.setAttribute('type', 'hidden');
          i.setAttribute('name', remoteMpi.name);
          i.setAttribute('value', this.bankData.cryptogramme);
        } else {
          i.setAttribute('type', 'hidden');
          i.setAttribute('name', remoteMpi.name);
          i.setAttribute('value', remoteMpi.value.toString());
        }
        f.appendChild(i);
      }
      const s = document.createElement('input');
      s.setAttribute('type', 'submit');
      s.setAttribute('value', 'Submit');
      f.appendChild(s);
      document.getElementsByTagName('body')[0].appendChild(f);
      // console.log(f);
      f.submit();
    }
    /*if (!this.id3 && this.order.total_price === 0) {
     console.log('gratuit ici');
    }*/
    if (!this.order.id && (this.id3 || this.order.total_price === 0)) {
      this.pendingRequest = true;
      this.paymentService.doPayment(this.order).then(res => {
        console.log(this.order);
        if(res == 'bank_data_incorect') {
          this.cleanErrors();
          this.messageEvent.emit('erreur');
          this.errors.push('Informations incorrectes ou provision insuffisante.');
        } else if(res == 'inssufisant') {
          this.cleanErrors();
          console.log('erreur');
          this.messageEvent.emit('erreur');
          this.errors.push('Provision insuffisante ou crédit dépassé');
        } else {
          this.cleanErrors();
          this.messageEvent.emit(res);
        }
      }).catch(error => {
        this.cleanErrors();
      })
    }
  }

  initMonthsAndDaysSelectArrays () {
    for (let i = 1; i <= 31; i++)
      this.daysArray.push(i);

    for (let i = 1; i <= 12; i++)
      this.monthsArray.push(i);
  }

  static displayErrors() {
    window.scrollTo(0, 0);
  }
}
